<template>
    <div>
        <b-modal
            id="lockDeviceModal"
            ref="lockDeviceModal"
            :lazy="true"
            :no-close-on-esc="true"
            :no-close-on-backdrop="true"
            :hide-header-close="true"
            @shown="shown"
            title="Unlock Device"
            title-tag="h2"
        >
            <!-- Modal Form -->
            <div v-if="message" class="alert alert-danger" role="alert">
                <i class="cus-error"></i>
                {{ message }}
            </div>
            <b-form
                id="unlockForm"
                @submit.stop.prevent="doSwitch"
                autocomplete="off"
            >
                <b-form-group
                    :label-for="`staff`"
                    label="Staff:"
                    label-cols="3"
                >
                    <v-select
                        id="staff"
                        ref="vselect"
                        :options="staff_options_exclude"
                        v-model="data.staff"
                        :class="{ 'border-danger': errors.has('staff') }"
                        @keydown.enter.prevent.stop
                        :label="'fullname'"
                        v-validate="'required'"
                        name="staff"
                    />
                </b-form-group>
                <b-form-group
                    :label-for="`st`"
                    label="Password:"
                    label-cols="3"
                >
                    <b-form-input
                        id="password"
                        v-model="data.password"
                        v-validate="'required'"
                        :class="{
                            'border-danger': errors.has('password'),
                            'password-mask': !togglePassword
                        }"
                        name="password"
                        autocomplete="off"
                        :type="togglePassword ? 'text' : 'password'"
                    ></b-form-input>
                    <b-button
                        variant="link"
                        class="password-toggle"
                        @click="togglePassword = !togglePassword"
                    >
                        <i class="fa fa-eye" v-if="togglePassword"></i>
                        <i class="fa fa-eye-slash" v-else></i>
                    </b-button>
                </b-form-group>
            </b-form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    @click="logout"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Log Out</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button
                        v-else
                        variant="primary"
                        form="unlockForm"
                        type="submit"
                        >Unlock</b-button
                    >
                </div>
            </div>
        </b-modal>
        <changedInstance ref="changedInstanceWindow" />
    </div>
</template>

<script>
import vSelect from "vue-select";
import ChangedInstance from "./changed-instance";
export default {
    name: "UnlockDevice",
    components: {
        vSelect,
        ChangedInstance
    },
    data() {
        return {
            data: {
                staff: null,
                staff_id: null,
                password: null
            },
            staffList: [],
            loading: false,
            message: null,
            selecting_user: false,
            togglePassword: false
        };
    },
    computed: {
        staff_options_exclude() {
            return _.difference(this.staffList, this.data.staff);
        }
    },
    mounted() {
        let self = this;
        // -- unlock modal
        if (window.localStorage.getItem("display_lock_device") == "true") {
            this.$refs["lockDeviceModal"].show();
        }
        // -- session checker
        this.checkCISession();

        //-- locked if triggered
        self._getSetting().then(() => {
            self.$socket.$subscribe(
                "lock_device:" + self.$root.currentActor.id,
                data => {
                    let message = $.parseJSON(data);
                    if (
                        message.lockDevice &&
                        message.session.session_id !=
                            self.$cookies.get("vettersession")
                    ) {
                        window.localStorage.setItem(
                            "display_lock_device",
                            "true"
                        );
                        self.$refs["lockDeviceModal"].show();
                    }
                }
            );
        });

        let login = self.$cookies.get("login");
        if (login == "true") {
            this.$refs.changedInstanceWindow.open();
        }
    },
    methods: {
        shown() {
            window.localStorage.setItem("display_lock_device", "true");
            this.getStaffList();
            this.$refs.vselect.$on("search:focus", event => {
                this.selecting_user = true;
                this.$refs.vselect.$once("search:blur", event => {
                    this.selecting_user = false;
                });
            });
        },
        logout() {
            window.localStorage.removeItem("sf_username");
            window.localStorage.removeItem("my_staff_url");
            window.localStorage.removeItem("display_lock_device");
            window.localStorage.removeItem("current_url");
            window.localStorage.removeItem("current_user");

            if (typeof newrelic !== "undefined") {
                // eslint-disable-next-line no-undef
                newrelic.addPageAction("view-logout", {
                    reason: "logout",
                    file: "lock.vue"
                });
            }

            this._redirect("/apps/index.php/welcome/logout");
        },
        getStaffList() {
            let self = this;
            self.loading = true;
            this.$http
                .get(process.env.ACTOR_SERVICE + "staff?getAll=1")
                .then(function (response) {
                    self.staffList = _.get(
                        response,
                        "data.response.resources",
                        []
                    );
                })
                .finally(() => (self.loading = false));
        },
        async doSwitch() {
            if (this.selecting_user) {
                return false;
            }
            let valid = await this.$validator.validateAll();
            if (!valid) {
                return false;
            }

            this.loading = true;
            let post = {
                staff_id: this.data.staff.id,
                password: this.data.password,
                vettersession: localStorage.getItem("vettersession")
            };

            try {
                let response = await $.post(
                    process.env.APPS + "index.php/ajax/staff/do_switch",
                    post,
                    null,
                    "json"
                ).then();

                if (response && response.change == 1) {
                    window.localStorage.removeItem("sf_username");
                    window.localStorage.removeItem("my_staff_url");
                    window.localStorage.removeItem("display_lock_device");
                    window.localStorage.setItem("current_url", response.url);
                    window.localStorage.setItem(
                        "current_user",
                        response.user_id
                    );
                    window.localStorage.setItem("Vetter-Token", response.token);
                    if (this.$root.currentActor.id == post.staff_id) {
                        this.$refs["lockDeviceModal"].hide();
                    } else {
                        this._redirect(
                            process.env.APPS +
                                "index.php/schedule/appointment/day?sw=1"
                        );
                    }
                } else if (response && response.change == 0) {
                    this.message = response.message;
                }
            } catch (error) {
                this.message = "Error in unlocking device.";
            } finally {
                this.loading = false;
            }
        },
        // Run every second to check if vettersession cookie is changing.
        // If value is different then redirect to logout. [zan]
        checkCISession() {
            let self = this;
            if (self.$cookies.isKey("vettersession")) {
                self.$root.vettersession = self.$cookies.get("vettersession");
            }

            let checkTtlService = setInterval(function () {
                let vettersessionBody = self.$root.vettersession;
                let vettersessionCookie = self.$cookies.get("vettersession");

                if (vettersessionBody) {
                    if (vettersessionBody != vettersessionCookie) {
                        self._message("Your session has expired.", "danger");
                        setTimeout(function () {
                            if (typeof newrelic !== "undefined") {
                                // eslint-disable-next-line no-undef
                                newrelic.addPageAction("view-logout", {
                                    reason: "session",
                                    file: "lock.vue"
                                });
                            }
                            self._redirect(
                                "/apps/index.php/welcome/logout?f=3"
                            );
                        }, 3000);
                        // --- stop this service
                        clearInterval(checkTtlService);
                    } else {
                        // Intended for keeping current's page url when switching business
                        if (window.localStorage.getItem("current_user")) {
                            let userId = self.$root.currentActor.id;
                            let currUserId = window.localStorage.getItem(
                                "current_user"
                            );

                            if (userId != currUserId) {
                                self._redirect(
                                    process.env.APPS +
                                        "index.php/welcome/redirect"
                                );
                            }
                        }
                        if (
                            window.localStorage.getItem(
                                "display_lock_device"
                            ) == "true"
                        ) {
                            self.$refs["lockDeviceModal"].show();
                        } else {
                            self.$refs["lockDeviceModal"].hide();
                        }
                    }
                }
            }, 3000);
        }
    }
};
</script>

<style scoped>
.password-toggle {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
}
</style>